import * as HttpService from "../../../../service/HttpService";
import TokenUtil from "../../../../utils/token-util";
/** 运维概览  -> 运行商概览服务 **/

/**
 * 获取 客户数,总容量，监控点数量以及托管资产
 */
export const getResourcesAndAssets = () => {
  return HttpService.get(
    HttpService.DOMAIN + "/viewReResource/getCountsByIdOrOrgNo"
  );
};

/**
 * 获取累计电量
 * @param type 1:月  2:年
 */
export const getStatisticPower = (type) => {
  return HttpService.get(
    HttpService.DOMAIN +
      "/viewStatisticalPower/getStatisticalElectric?type=" +
      type
  );
};

/**
 * 获取负荷信息
 * @param type 1：日  2：年
 */
export const getLoadInfo = (type) => {
  return HttpService.get(
    HttpService.DOMAIN + "/viewStatisticalPower/getStatisticalLoad?type=" + type
  );
};

/**
 * 获取告警信息
 */
export const getWaringInfo = (id) => {
  return HttpService.get(
    HttpService.DOMAIN + "/viewSoeRecord/getSoeRecordList?orgNo=" + id
  );
};

/**
 * 获取采集器在线率
 */
export const getDeviceOnlineRate = () => {
  return HttpService.get(
    HttpService.DOMAIN + "/viewDeviceOnlineRate/getDeviceOnlineRate"
  );
};

/**
 * 获取运维服务信息
 */
export const getOpsInfo = () => {
  return HttpService.get(
    HttpService.DOMAIN + "/workOrderOvw/getThisMonthWorkNumOfStat"
  );
};

/**
 * 获取光伏运维服务信息
 */
export const getPvOpsInfo = (custId, id) => {
  if (custId) {
    return HttpService.get(
      HttpService.DOMAIN +
        "/workOrderOvw/getThisMonthWorkNumOfStat?custId=" +
        custId +
        "&orgNo=" +
        id
    );
  } else {
    return HttpService.get(
      HttpService.DOMAIN +
        "/workOrderOvw/getThisMonthWorkNumOfStat?orgNo=" + id
    );
  }
};

/**
 * 获取用能客户列表 (模糊搜索)
 * @param name 客户名称
 * @returns {Promise<Response>}
 */
export const getCustomListByName = (name, type) => {
  return HttpService.get(
    HttpService.DOMAIN +
      "/viewCeCust/getCustInfo?name=" +
      name +
      "&pageType=" +
      type
  );
};

/**
 * 获取告警信息
 */
 export const getOrderInfo = (data) => {
  return HttpService.get(
    HttpService.DOMAIN + "/newkngf/pvWorkOrder/workOrderRate?orgNo=" + data.id+"&inveModel="+data.type
  );
};

/**
 * 建设总览（集团页）-日（月）均有效时数
 */
 export const getEffectiveHours = (data) => {
  return HttpService.get(
    HttpService.DOMAIN + "/viewStatisticalPower/effectiveHours?orgNo=" + data.id+"&inveModel="+data.type
  );
};

/**
 * 建设总览（集团页）-日（月）均有效时数
 */
 export const getFaDian = (data) => {
  return HttpService.get(
    HttpService.DOMAIN + "/viewStatisticalPower/eqHhoursDay?orgNo=" +data.id+"&inveModel="+data.type
  );
};

/**
 *建设总览分部页--发电效率分析导出
 */
export const pvEffExportExcel = (id) => {
  const token = TokenUtil.getToken();
  return (
    HttpService.DOMAIN +
    `/viewStatisticalPower/pvEffExportExcel?orgNo=${id}&bearer=${token}`
  );
};

/**
 *碳中和排名
 */
 export const queryCarbonNeutralRanking = (data) => {
  return HttpService.get(HttpService.DOMAIN + "/sanJiBigScreen/queryCarbonNeutralRanking");
};
